// Custom segments for each land use context
import { SEGMENTS_MAIN_STREET } from './segments/MainStreet.segment'
import { SEGMENTS_URBAN_OR_WALKABLE_THOROUGHFARE } from './segments/UrbanOrWalkableThoroughfare.segment'
import { SEGMENTS_SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL } from './segments/SmallTownHamletOrVillageCommercial.segment'
import { SEGMENTS_SUBURBAN_CORRIDORS } from './segments/SuburbanCorridors.segment'
import { SEGMENTS_RURAL } from './segments/Rural.segment'

export const MAIN_STREET = 'Main Street'
export const URBAN_OR_WALKABLE_THOROUGHFARE = 'Urban or Walkable Thoroughfare'
export const SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL =
  'Small Town Hamlet or Village Commercial'
export const SUBURBAN_CORRIDORS = 'Suburban Corridors'
export const RURAL = 'Rural'

export const LAND_USE_CONTEXT = [
  MAIN_STREET,
  URBAN_OR_WALKABLE_THOROUGHFARE,
  SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL,
  SUBURBAN_CORRIDORS,
  RURAL
]

export const STREET_SEGMENTS = {
  [MAIN_STREET]: SEGMENTS_MAIN_STREET,
  [URBAN_OR_WALKABLE_THOROUGHFARE]: SEGMENTS_URBAN_OR_WALKABLE_THOROUGHFARE,
  [SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL]:
    SEGMENTS_SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL,
  [SUBURBAN_CORRIDORS]: SEGMENTS_SUBURBAN_CORRIDORS,
  [RURAL]: SEGMENTS_RURAL
}
